import AbstractCollection from "./abstractCollection";

class UserCollection extends AbstractCollection {
  /**
   *
   * @param {User[]} users
   */
  constructor(users) {
    super(users);
    this.loaded = !!users;
  }

  /**
   *
   * @returns {Team[]}
   */
  asArray() {
    const users = this.items;
    users.sort((a, b) => {
      if (a.lastName === b.lastName) {
        if (a.firstName === b.firstName) return 0;
        return a.firstName < b.firstName ? -1 : 1;
      }
      return a.lastName < b.lastName ? -1 : 1;
    });

    return users;
  }

  /**
   *
   * @param {string} username
   * @param {boolean} [throwError=true]
   * @returns {?User}
   */
  getUserByUsername(username, throwError = true) {
    return this.getItem({ username }, throwError);
  }
}

export default UserCollection;
